import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
// bcryptjs removed — password hashing must only happen server-side.
// ISO 27001 A.8.5 / SOC 2 CC6.1
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const validatePassword = (password) => {
    const lengthValid = password.length >= 12 && password.length <= 16;
    const hasUppercase = /[A-Z]/.test(password);
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasNumber = /\d/.test(password);
    return lengthValid && hasUppercase && hasSymbol && hasNumber;
  };

  const handleReset = async (e) => {
    e.preventDefault();

    if (!validatePassword(password)) {
      toast.error('Password must be 12–16 characters, include an uppercase letter, a symbol, and a number.');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Passwords do not match.');
      return;
    }

    try {
      // Password sent over HTTPS — server handles hashing (ISO 27001 A.8.5)
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/tradereset-password`, {
        token,
        password,
      });

      if (res.data.success) {
        toast.success('Password reset successful! Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        toast.error(res.data.message || 'Password reset failed.');
      }
    } catch (err) {
      console.error('Reset error:', err);
              // Show backend error message if available, otherwise generic error
              if (err.response && err.response.data && err.response.data.message) {
                  toast.error(err.response.data.message);
              } else {
                  toast.error('Something went wrong.');
              }
    }
  };

  return (
    <form className="login-form" onSubmit={handleReset}>
      <h2>Reset Your Password</h2>
      <input
        type="password"
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <input
        type="password"
        placeholder="Confirm New Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        required
      />
      <button type="submit">Reset Password</button>
    </form>
  );
};

export default ResetPassword;
